import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import NewsletterSubscribe from '@/components/NewsletterSubscribe';
import { ORG } from '@/config/org';

// Footer links configuration
const quickLinks = [
  { to: '/about', label: 'About Us' },
  { to: '/give', label: 'Give — QR-friendly donation page', style: 'font-semibold text-emerald-400', icon: Heart },
  { to: '/our-pledge', label: 'Our Pledge', style: 'font-semibold text-emerald-400', icon: Heart },
  { to: '/fundraiser', label: 'Dream Project', style: 'font-semibold text-violet-400', icon: Heart },
  { to: '/capital-readiness', label: 'Capital Readiness Hub', style: 'font-semibold text-[#A4D65E]' },
  { to: '/retail-launchpad', label: 'Retail Launchpad', style: 'font-semibold text-indigo-400' },
  { to: '/disaster-hub', label: 'Disaster Hub', style: 'font-semibold text-orange-400' },
  { to: '/businesses', label: 'Business Directory' },
  { to: '/business-map', label: 'Business Map' },
  { to: '/grants', label: 'Grants & Funding' },
  { to: '/seven-fs', label: 'The 7Fs Methodology', style: 'font-semibold text-[#A4D65E]' },
  { to: '/resource-library', label: 'Resource Library' },
  { to: '/blog', label: 'Blog & Podcast' },
  { to: '/global-biz-resources', label: 'Global Biz Resources' },
  { to: '/louisiana-biz-resources', label: 'Louisiana Biz Resources' },
];

const getInvolvedLinks = [
  { to: '/community-feedback', label: '💬 Send Feedback', style: 'text-[#A4D65E] font-semibold' },
  { to: '/youth-track', label: '🎓 Youth Track (13-18)', style: 'text-blue-400 font-semibold' },
  { to: '/community-track', label: '💼 Community Track', style: 'text-green-400 font-semibold' },
  { to: '/workforce', label: 'wUrkForce Development', style: 'text-blue-400' },
  { to: '/faith', label: 'Faith wUrks', style: 'text-amber-400' },
  { to: '/fitness', label: 'wUrkFit', style: 'text-rose-400' },
  { to: '/foundation', label: 'School 4 Thought', style: 'text-purple-400' },
  { to: '/food', label: 'Farm2Table', style: 'text-orange-400' },
  { to: '/legacystudio', label: 'LegacyStudio', style: 'text-violet-400' },
  { to: '/financial-literacy', label: 'Financial Literacy', style: 'text-emerald-400' },
  { to: '/donate', label: 'Donate' },
  { to: '/volunteer-hub', label: 'Volunteer Hub' },
  { to: '/proof', label: 'PROOF System', style: 'text-green-400 font-semibold' },
  { to: '/badges', label: 'Open Badges', style: 'text-yellow-400' },
  { to: '/community', label: 'Community' },
  { to: '/events', label: 'Events' },
  { to: '/contact', label: 'Contact Us' },
];

const legalLinks = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-of-use', label: 'Terms of Use' },
  { to: '/content-rights', label: 'Content Rights' },
  { to: '/refund-policy', label: 'Refund Policy' },
  { to: '/takedown-policy', label: 'Takedown Policy' },
  { to: '/compliance', label: 'Security & Compliance', style: 'text-green-400' },
  { to: '/data-request', label: 'Data Request (GDPR)' },
];

const socialLinks = [
  { href: 'https://www.facebook.com/DowUrkinc', icon: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
  { href: 'https://www.instagram.com/dowurkinc', icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z' },
  { href: 'https://www.twitter.com/dowurkinc', icon: 'M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z' },
  { href: 'https://www.youtube.com/channel/UCDFERb6RQLbxlErcPrUA94w', icon: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' },
  { href: 'https://www.linkedin.com/company/dowurk-inc/', icon: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' },
];

function FooterLinkSection({ title, links }) {
  return (
    <div>
      <h4 className="font-semibold mb-3">{title}</h4>
      <ul className="space-y-2 text-sm text-gray-400">
        {links.map(link => (
          <li key={link.to}>
            <Link to={link.to} className={`hover:text-white ${link.style || ''} ${link.icon ? 'flex items-center gap-1' : ''}`}>
              {link.icon && <link.icon className="h-3 w-3" />}
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_equity-focus/artifacts/875dlk3n_dowurk_color_shield.png" 
              alt="DowUrk Shield" 
              className="w-16 h-16 mb-4 object-contain"
              loading="lazy"
            />
            <h3 className="text-lg font-bold mb-4">DowUrk<sup className="text-xs">®</sup> Inc.</h3>
            <p className="text-gray-400 text-sm mb-4">
              Empowering small businesses and entrepreneurs worldwide through technology, community, and opportunity.
            </p>
            <p className="text-sm font-semibold bg-gradient-to-r from-[#A4D65E] to-white bg-clip-text text-transparent">
              Cultivating Originality.
            </p>
          </div>

          <FooterLinkSection title="Quick Links" links={quickLinks} />
          <FooterLinkSection title="Get Involved" links={getInvolvedLinks} />

          {/* Legal & Contact Column */}
          <div>
            <h4 className="font-semibold mb-3">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              {legalLinks.map(link => (
                <li key={link.to}>
                  <Link to={link.to} className={`hover:text-white ${link.style || ''}`}>{link.label}</Link>
                </li>
              ))}
              <li>
                <a 
                  href="https://customer-assets.emergentagent.com/job_23679490-9601-46e6-8c09-8a2a2e838147/artifacts/q0dr0ma6_DowUrk_Brand_Guidelines_2026.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-white"
                >
                  Brand Guidelines
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="font-semibold mb-3">Connect With Us</h4>
            <p className="text-gray-400 text-sm mb-3" data-testid="footer-contact-block">
              {ORG.address.street}<br />
              {ORG.address.city}, {ORG.address.state} {ORG.address.zip}<br />
              <a
                href={`tel:${ORG.contact.primaryPhoneTel}`}
                className="hover:text-white"
                data-testid="footer-phone-link"
              >
                {ORG.contact.primaryPhone}
              </a><br />
              <a
                href={`mailto:${ORG.contact.primaryEmail}`}
                className="hover:text-white"
                data-testid="footer-email-link"
              >
                {ORG.contact.primaryEmail}
              </a>
            </p>
            
            {/* Newsletter Signup */}
            <div className="mt-4 mb-4">
              <NewsletterSubscribe variant="inline" className="flex-col gap-2" />
            </div>
            
            {/* Social Links */}
            <div className="flex space-x-3 mt-4">
              {socialLinks.map((social, idx) => (
                <a 
                  key={`social-${idx}`}
                  href={social.href} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="h-10 w-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#A4D65E] transition"
                >
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d={social.icon} />
                  </svg>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Candid Gold Transparency Seal — auto-updates from Candid CDN */}
        <div
          className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row items-center md:items-start justify-center md:justify-start gap-5 md:gap-6"
          data-testid="footer-candid-seal-section"
        >
          <a
            aria-label="DowUrk Inc. Candid Gold Transparency 2026 Seal"
            href="https://app.candid.org/profile/15332253/dowurk-inc-81-3555399/?pkId=4d04813a-057a-4745-a1b7-d7c1cafaeb92"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 bg-white rounded-md p-2 hover:opacity-90 transition"
            data-testid="footer-candid-seal-link"
          >
            <img
              alt="DowUrk Inc. — Candid Gold Transparency 2026"
              src="https://widgets.guidestar.org/prod/v1/pdp/transparency-seal/15332253/svg"
              className="h-24 w-24 object-contain"
              loading="lazy"
            />
          </a>
          <p className="text-sm text-gray-300 max-w-2xl text-center md:text-left leading-relaxed">
            DowUrk<sup className="text-xs">®</sup> Inc. is proud to demonstrate our dedication to excellence
            through our commitment to{' '}
            <a
              href="https://app.candid.org/profile/15332253/dowurk-inc-81-3555399/?pkId=4d04813a-057a-4745-a1b7-d7c1cafaeb92"
              target="_blank"
              rel="noopener noreferrer"
              className="text-amber-300 hover:text-amber-200 underline font-semibold"
            >
              nonprofit transparency
            </a>
            . Verified by Candid · Gold Transparency 2026.
          </p>
        </div>

        {/* Bottom Bar — institutional credibility band (verifiable identifiers) */}
        <div
          className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-400"
          data-testid="footer-trust-band"
        >
          <p>
            © {new Date().getFullYear()} {ORG.legalName} All rights reserved. ·
            Empowering Entrepreneurs Worldwide
          </p>
          <ul
            className="flex flex-wrap items-center justify-center gap-2"
            aria-label="Verification and compliance"
          >
            {/* SAM.gov · UEI (links to public registry) */}
            <li>
              <a
                href={ORG.samProfileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 transition-colors px-3 py-1.5 rounded-full"
                data-testid="footer-trust-uei"
              >
                <svg className="h-4 w-4 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                <span className="text-xs text-blue-400">
                  SAM.gov · UEI {ORG.ueiCode}
                </span>
              </a>
            </li>
            {/* CAGE Code */}
            <li
              className="flex items-center gap-2 bg-gray-800 px-3 py-1.5 rounded-full"
              data-testid="footer-trust-cage"
            >
              <svg className="h-4 w-4 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span className="text-xs text-amber-400">CAGE {ORG.cageCode}</span>
            </li>
            {/* EIN */}
            <li
              className="flex items-center gap-2 bg-gray-800 px-3 py-1.5 rounded-full"
              data-testid="footer-trust-ein"
            >
              <span className="text-xs text-emerald-300">EIN {ORG.ein}</span>
            </li>
            {/* 501(c)(3) Badge */}
            <li
              className="flex items-center gap-2 bg-gray-800 px-3 py-1.5 rounded-full"
              data-testid="footer-trust-501c3"
            >
              <svg className="h-4 w-4 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span className="text-xs text-blue-400">{ORG.irsStatus}</span>
            </li>
            {/* Candid Gold Transparency 2026 */}
            <li>
              <a
                href={ORG.candidProfileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 transition-colors px-3 py-1.5 rounded-full"
                data-testid="footer-trust-candid"
              >
                <svg className="h-4 w-4 text-amber-300" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2l2.4 7.4H22l-6 4.4 2.3 7.2L12 16.8 5.7 21l2.3-7.2-6-4.4h7.6z" />
                </svg>
                <span className="text-xs text-amber-300">
                  Candid {ORG.certifications.candidSeal}
                </span>
              </a>
            </li>
            {/* SSL Security Badge */}
            <li
              className="flex items-center gap-2 bg-gray-800 px-3 py-1.5 rounded-full"
              data-testid="footer-trust-ssl"
            >
              <svg className="h-4 w-4 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
              <span className="text-xs text-green-400">SSL Secured</span>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
